import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import Landing from "@/pages/Landing";
import { PrivacyPolicy, TermsConditions, CookiePolicy } from "@/pages/Legal";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, wheelMultiplier: 1 }}>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
          <Toaster position="bottom-right" />
        </ReactLenis>
      </BrowserRouter>
    </div>
  );
}

export default App;
